import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { UiProgressBarModule } from '@modules';
import { TranslateModule } from '@ngx-translate/core';
import { SettingService } from '@services/setting.service';

import { UiPasswordIndicatorComponent } from './ui-password-indicator.component';

@NgModule({
    imports: [
        CommonModule,
        MatListModule,
        UiProgressBarModule,
        MatIconModule,
        TranslateModule,
    ],
    declarations: [
        UiPasswordIndicatorComponent,
    ],
    exports: [
        UiPasswordIndicatorComponent,
    ],
    providers: [
        SettingService,
    ],
})
export class UiPasswordIndicatorModule { }
